function median(values) {
    values.sort();
    const mid_idx = Math.floor(values.length / 2);
    return values.length % 2 === 1 ? values[mid_idx] : (values[mid_idx - 1] + values[mid_idx]) / 2;
}
function mean(values) {
    return values.reduce((x, y) => x + y, 0) / (values.length || 1);
}
function get_iqr_min_max(values) {
    values.sort((a, b) => a - b);
    function generate_acceptable(vs) {
        let midpt = Math.floor(vs.length / 2);
        let q1 = median(vs.slice(0, midpt));
        let q3;
        if (vs.length % 2 === 0) {
            q3 = median(vs.slice(midpt));
        }
        else {
            q3 = median(vs.slice(midpt + 1));
        }
        let iqr = q3 - q1;
        let acceptable_max = Math.min(q3 + iqr * 1.5, Math.max(...vs));
        let acceptable_min = Math.max(q1 - iqr * 1.5, Math.min(...vs));
        return { max: acceptable_max, min: acceptable_min };
    }
    let reduced = values.sort((a, b) => a - b);
    let acceptables = generate_acceptable(reduced);
    let acceptable_max = acceptables.max;
    let acceptable_min = acceptables.min;
    while (acceptable_max === acceptable_min) {
        reduced = reduced.filter(v => v !== acceptable_max);
        if (reduced.length <= 1)
            break;
        acceptables = generate_acceptable(reduced);
        acceptable_max = acceptables.max;
        acceptable_min = acceptables.min;
    }
    return acceptables;
}
export function get_stats(values) {
    let numeric_data = values.concat();
    numeric_data.sort();
    let acc_min_max = get_iqr_min_max(numeric_data);
    let filtered = numeric_data.filter(v => v <= acc_min_max.max && v >= acc_min_max.min);
    let filtered_mean = mean(filtered);
    let sum_sq_diff = filtered.map(v => Math.pow(v - filtered_mean, 2)).reduce((x, y) => x + y, 0);
    let std_deviation = Math.sqrt(sum_sq_diff / (filtered.length || 1));
    return { max: acc_min_max.max, min: acc_min_max.min, mean: filtered_mean, std_dev: std_deviation };
}
export function interpolate(min, max, steps) {
    if (steps === 0)
        return [];
    if (steps === 1)
        return [(max + min) / 2];
    if (max === min)
        return [min];
    let delta = (max - min) / ((steps - 1) || 1);
    let list = [];
    for (let i = 0; i < steps; i++) {
        list[i] = min + i * delta;
    }
    return list;
}
